var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5V3.1C11 2.53995 11 2.25992 10.891 2.04601C10.7951 1.85785 10.6422 1.70487 10.454 1.60899C10.2401 1.5 9.96005 1.5 9.4 1.5H3.1C2.53995 1.5 2.25992 1.5 2.04601 1.60899C1.85785 1.70487 1.70487 1.85785 1.60899 2.04601C1.5 2.25992 1.5 2.53995 1.5 3.1V9.4C1.5 9.96005 1.5 10.2401 1.60899 10.454C1.70487 10.6422 1.85785 10.7951 2.04601 10.891C2.25992 11 2.53995 11 3.1 11H5M11 5H6.6C6.03995 5 5.75992 5 5.54601 5.10899C5.35785 5.20487 5.20487 5.35785 5.10899 5.54601C5 5.75992 5 6.03995 5 6.6V11M11 5H12.9C13.4601 5 13.7401 5 13.954 5.10899C14.1422 5.20487 14.2951 5.35785 14.391 5.54601C14.5 5.75992 14.5 6.03995 14.5 6.6V12.9C14.5 13.4601 14.5 13.7401 14.391 13.954C14.2951 14.1422 14.1422 14.2951 13.954 14.391C13.7401 14.5 13.4601 14.5 12.9 14.5H6.6C6.03995 14.5 5.75992 14.5 5.54601 14.391C5.35785 14.2951 5.20487 14.1422 5.10899 13.954C5 13.7401 5 13.4601 5 12.9V11",
    stroke: "#020817"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicate_icon.6c52b7f28ee9206ab52f096876bf71fd.svg";
export { ForwardRef as ReactComponent };